import styled from "@emotion/styled/macro"
import { theme, device } from "../Theme"

const TestimonialContainer = styled.section`
  background: #000;
`

const InnerContainer = styled.div`
  width: 100%;
  padding: 58px 0 53px;
  display: flex;
  flex-direction: column;

  @media ${device.md} {
    padding: 103px 0 100px;
  }

  @media ${device.xl} {
    display: grid;
    grid-template-columns: 50% 50%;
  }
`

const VideoSection = styled.div`
  position: relative;
  width: 100%;
  height: 350px;
  position: relative;
  overflow: hidden;
`

const VideoSectionPlayer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  background: ${theme.colors.primary};

  .react-player {
    opacity: 0.7;
    transform: translate(-100px, 0);
  }
`

const VideoSectionContent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
`

const VideoSectionCard = styled.div`
  margin: 0 24px 10px 24px;
  padding: 12px;
  background: #fff;
  border: 1px solid #707070;

  @media ${device.lg} {
    padding: 24px;
  }

  & > .content {
    font-family: ${theme.fonts.altFont};
    font-size: 18px;
    font-style: italic;
    font-weight: 700;
    line-height: 21px;
    text-align: center;
    margin-bottom: 8px;
    margin-top: 0 !important;
    color: #323030;
  }

  & > .name,
  & > .customer {
    font-family: ${theme.fonts.main};
    font-size: 15px;
    font-weight: 800;
    line-height: 15px;
    letter-spacing: 0.09px;
    text-align: center;
    margin: 8px 0 0;

    &.customer {
      margin: 0;
      font-size: 13px;
      font-weight: 600;
    }
  }

  & > .divider {
    width: 57px;
    height: 2px;
    min-height: 2px;
    background: #e32223;
    margin: 0 auto;

    @media ${device.sm} {
      width: 112px;
    }
  }
`

const PlayButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  & > svg {
    width: 72px;
    height: 72px;
  }

  @media ${device.sm} {
    & > svg {
      width: 100px;
      height: 100px;
    }
  }
`

const ContentSection = styled.div`
  margin: 43px 24px 0 24px;

  @media ${device.sm} {
    margin: 43px 86px 0 68px;
  }
`

const Label = styled.label`
  font-family: ${theme.fonts.altFont};
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  color: #e32223;
  margin: 0 0 11px;
  text-transform: uppercase;
  display: block;

  @media ${device.md} {
    font-size: 36px;
    text-align: left;
    margin: 0 0 20px;
  }
`

const Heading = styled.span`
  font-family: ${theme.fonts.main};
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -1px;
  text-align: center;
  margin: 0 0 6px;
  color: #ffffff;
  display: block;

  @media ${device.md} {
    font-size: 64px;
    text-align: left;
    letter-spacing: -2px;
  }
`

const SubHeading = styled.h1`
  font-family: ${theme.fonts.main};
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.2px;
  text-align: center;
  margin: 0 0 28px;
  color: #ffffff;

  @media ${device.md} {
    text-align: left;
  }
`

const ContentDivider = styled.div`
  margin: 0 auto 38px;
  min-height: 2px;
  height: 2px;
  width: 232px;
  background: #fff;
  position: relative;

  @media ${device.md} {
    width: 353px;
    margin: 0 0 38px 24px;
  }

  &:before {
    content: " ";
    width: 14px;
    height: 14px;
    min-height: 14px;
    border: 2px solid #fff;
    background: transparent;
    position: absolute;
    top: -8px;
    left: -18px;
  }

  &:after {
    content: " ";
    width: 10px;
    height: 10px;
    background: #e32223;
    position: absolute;
    top: -4px;
    left: -10px;
  }
`

const Content = styled.div`
  font-family: ${theme.fonts.main};
  font-size: 19px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.2px;
  text-align: center;
  color: #8b8b8b;
  margin: 0 0 28px;
  color: #8b8b8b;

  @media ${device.md} {
    font-size: 24px;
    line-height: 35px;
    text-align: left;
    margin: 0 0 64px;
  }
`

const VideoMask = styled.div`
  position: absolute;
  left: -3px;
  right: -3px;
  bottom: -3px;
  width: calc(100% + 16px);

  & > * {
    width: 100%;
  }
`

const ReviewSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const ReviewSection = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  margin-top: 32px;

  @media ${device.sm} {
    margin-top: 44px;
  }
`

const ReviewAll = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0 0;

  & > button {
    letter-spacing: 2px;
    white-space: nowrap;
  }

  @media ${device.md} {
    margin: 50px 0 0;
  }
`

const SliderController = styled.div`
  display: flex;
  justify-content: center;
  order: 2;
  align-items: center;
  margin-top: 20px;

  @media ${device.md} {
    justify-content: flex-end;
    order: 0;
    margin-top: 0;
  }
`

const ArrowButton = styled.button`
  background: transparent;
  cursor: pointer;
  margin: 0 0 0 26px;
  padding: 0;
  outline: none;
  border: none;

  & > svg {
    width: 44px;
    height: 44px;
  }

  @media ${device.sm} {
    & > svg {
      width: 56px;
      height: 56px;
    }
  }
`
const CloseButton = styled.button`
  appearance: none;
  position: absolute;
  top: 20px;
  right: 20px;
  border: none;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.light};
  padding: 10px;
  &:hover {
    cursor: pointer;
  }
`

export {
  TestimonialContainer,
  InnerContainer,
  VideoSection,
  ContentSection,
  VideoSectionPlayer,
  VideoSectionContent,
  VideoSectionCard,
  PlayButton,
  Label,
  Heading,
  SubHeading,
  ContentDivider,
  Content,
  VideoMask,
  ReviewSliderContainer,
  ReviewSection,
  ReviewAll,
  SliderController,
  ArrowButton,
  CloseButton,
}
